import ENV from "app/utils/ENV";
import apiActions from "app/utils/apiActions";
import alertActions from "app/utils/alertActions";
import storageActions from "app/utils/storageActions";
import chapterHelpers from "app/utils/chapterHelpers";
import locationHelpers from "app/utils/locationHelpers";

import store from "app/redux/store";
// import { index, create, update } from "app/actions/chapters";
import { setLoading, setUpdatedAt } from "app/actions/app";
import { add } from "app/actions/values";
// import { add } from "app/actions/moments";

let chapterActions = {
  async index() {
    return await apiActions.request("chapters");
  },
  async timeline(page = 1) {
    store.dispatch(setLoading(true));
    let res = await apiActions.request(`chapters/timeline?page=${page}`);
    store.dispatch(setLoading(false));
    return res;
  },
  async waves(selectedValueIds = [], excludeValueIds = []) {
    store.dispatch(setLoading(true));
    let params = "";
    if (selectedValueIds.length > 0) {
      params += `?value_ids=${selectedValueIds.join(",")}`;
    }
    if (excludeValueIds.length > 0) {
      if (params.length > 0) params += "&";
      else params += "?";
      params += `exclude_ids=${excludeValueIds.join(",")}`;
    }
    let res = await apiActions.request(`chapters/waves${params}`);
    store.dispatch(setLoading(false));
    return res;
  },
  async calendar(startDate, endDate) {
    const fmt = (d) => d.toISOString().slice(0, 10);
    const res = await apiActions.request('chapters/calendar', 'GET', {
      start_date: fmt(startDate),
      end_date: fmt(endDate),
    });
    if (res?.success) {
      store.dispatch({ type: 'chapters/index', chapters: res.chapters });
      const values = res.chapters
        .flatMap(c => c.moments?.map(m => m.value) || [])
        .filter(Boolean);
      store.dispatch(add(values));
    }
    return res;
  },

  async current(range, date = null) {
    store.dispatch(setLoading(true));
    let res = await apiActions.request("chapters/current", "GET", {
      range,
      date,
    });
    store.dispatch(setLoading(false));
    if (res?.success) {
      // keep the latest "now" view available for offline cold starts
      if (!date)
        storageActions.saveItem(`cached_chapters_current_${range}`, res);
    } else if (!res && !date && store.getState().app?.isOnline === false) {
      let cached = await storageActions.fetchItem(
        `cached_chapters_current_${range}`,
        null,
      );
      if (cached?.success) {
        res = { ...cached, fromCache: true };
      }
    }
    if (res?.success) {
      let allChapters = [
        ...res.top_chapters,
        ...res.sub_chapters,
        ...res.atemporal_chapters,
      ];
      let values = allChapters
        .map((c) => {
          return [
            ...c.moments.map((m) => m.value),
            ...(c.references || []),
          ].flat();
        })
        .flat()
        .filter((x) => !!x);

      // let values = [
      //   ...(res.top_chapters
      //     .map((c) => c.moments.map((m) => m.value).flat())
      //     .flat() || []),
      //   ...(res.sub_chapters
      //     .map((c) => c.moments.map((m) => m.value).flat())
      //     .flat() || []),
      //   ...(res.atemporal_chapters
      //     .map((c) => c.moments.map((m) => m.value).flat())
      //     .flat() || []),
      //   ...(res.chapter)
      // ].filter((x) => !!x);
      store.dispatch(add(values));
      // store.dispatch(addMoments(moments));

      store.dispatch({
        type: "chapters/index",
        chapters: [
          ...res.top_chapters,
          ...res.sub_chapters,
          ...res.atemporal_chapters,
        ],
      });
    }
    return res;
  },
  async show(id, date = null) {
    let res = await apiActions.request(`chapters/${id}`, "GET", {
      date,
    });
    if (res?.success) {
      store.dispatch({
        type: "chapters/index",
        chapters: [res.chapter, ...res.sub_chapters],
      });
      let allChapters = [res.chapter, ...(res.sub_chapters || [])];
      let values = allChapters
        .map((c) => {
          return [
            ...c.moments.map((m) => m.value),
            ...(c.references || []),
          ].flat();
        })
        .flat()
        .filter((x) => !!x);

      // let values = [
      //   ...(res.chapter.moments?.map((m) => m.value) || []),
      //   ...(res.chapter.references || []),
      //   ...(res.sub_chapters.moments?.map((m) => m.value) || []),
      // ].filter((x) => !!x);
      store.dispatch(add(values));
      // store.dispatch({ type: "chapters/update", chapter: res.chapter });

      if (res.chapter?.current) {
        storageActions.saveItem("cached_chapter_today", res);
      }
    }
    return res;
  },
  async allActivity(id) {
    let res = await apiActions.request(`chapters/${id}`, "GET", {
      all_activity: true,
    });
    return res;
  },
  async update(id, data) {
    return await apiActions.request(`chapters/${id}`, "PATCH", data);
  },
  async delete(id) {
    return await apiActions.request(`chapters/${id}`, "DELETE");
  },
  // removes the chapter's open pins that saw no activity that day
  async clearOpenMoments(id) {
    let res = await apiActions.request(
      `chapters/${id}/clear_open_moments`,
      "POST",
    );
    if (res?.success && res.chapter) {
      store.dispatch({ type: "chapters/update", chapter: res.chapter });
    }
    return res;
  },
  async sortMoments(id, moment_ids) {
    let res = await apiActions.request(`chapters/${id}/sort_moments`, "PATCH", {
      moment_ids,
    });
    if (res?.success) {
      // console.log("res", res.chapter);
      store.dispatch({ type: "chapters/update", chapter: res.chapter });
    }
    return res;
  },
  async create(data = {}, parentChapter = null) {
    let res = await apiActions.request(`chapters`, "POST", data);
    if (res?.success) {
      store.dispatch({ type: "chapters/update", chapter: res.chapter });
      if (!!parentChapter) {
        let updatedParent = {
          ...parentChapter,
          sub_chapter_ids: [...parentChapter.sub_chapter_ids, res.chapter.id],
        };
        store.dispatch({ type: "chapters/update", chapter: updatedParent });
      }
    }
    return res;
  },
  async dismissSuggestion(chapter, value_id) {
    let valueIds = typeof value_id == "object" ? value_id : [value_id];
    let data = {
      dismissed_suggestions: [...(chapter.dismissed_suggestions || []), ...valueIds],
    };
    // console.log(data);
    let res = await apiActions.request(`chapters/${chapter.id}`, "PATCH", data);
    console.log(res);
    if (res?.success) {
      store.dispatch({ type: "chapters/update", chapter: res.chapter });
    }
    return res;
  },
  async undismissSuggestion(chapter, value_id) {
    let data = {
      dismissed_suggestions: (chapter.dismissed_suggestions || []).filter((id) => id !== value_id),
    };
    let res = await apiActions.request(`chapters/${chapter.id}`, "PATCH", data);
    if (res?.success) {
      store.dispatch({ type: "chapters/update", chapter: res.chapter });
    }
    return res;
  },
  async pinValue(id, value_id, params = {}) {
    let data = { value_id, ...params };

    let location = await locationHelpers.getLocation();
    if (!!location?.coords) {
      data.lat = location.coords.latitude;
      data.lon = location.coords.longitude;
    }

    console.log("PIN", data);
    let res = await apiActions.request(
      `chapters/${id}/create_moment`,
      "POST",
      data,
    );
    console.log(res);
    if (res?.success) {
      store.dispatch({ type: "chapters/update", chapter: res.chapter });
    }
    return res;
  },
  async pinValueByDate(date, value) {
    let data = { date, value_id: value.id };
    if (value.completed_at) data.completed_at = value.completed_at;
    let res = await apiActions.request(
      `chapters/create_moment_by_date`,
      "POST",
      data,
    );
    console.log(res);
    if (res?.success) {
      await store.dispatch({ type: "chapters/update", chapter: res.chapter });
    }
    return res;
  },
  async createValue(id, params) {
    let data = { ...params };
    return await apiActions.request(
      `chapters/${id}/create_moment`,
      "POST",
      data,
    );
  },
  async rollover(id, parent_id) {
    let conf = await alertActions.confirm({
      title: `Roll over incomplete items to next chapter?`,
      // text: "Confirm",
      options: ["Confirm", "Include Notes"],
      optionStyles: [null, "secondary"],
    });
    let include_notes = conf == 2;
    if (!conf) return;
    let data = { parent_id, include_notes };
    let res = await apiActions.request(
      `chapters/${id}/rollover_moments`,
      "POST",
      data,
    );
    if (res?.success) {
      store.dispatch({ type: "chapters/update", chapter: res.chapter });
    }
    return res;
  },
  async getPreviousChapter(id) {
    let res = await apiActions.request(`chapters/${id}/get_previous_chapter`);
    if (res?.success) {
      store.dispatch({ type: "chapters/update", chapter: res.chapter });
    }
    return res;
  },
  async autocompleteChapters(query) {
    let chapters = await apiActions.request(
      `chapters/autocomplete_chapters`,
      "GET",
      { query },
    );
    chapters = [...chapters, ...chapterHelpers.autocompleteChapterNames(query)];
    return chapters;
  },
};

export default chapterActions;
